interface BackgroundShapeProps {
  size?: number;
  top?: number;
  right?: number;
  opacity?: number;
}

export default function BackgroundShape({
  size = 250,
  top = 10,
  right = 20,
  opacity = 0.1,
}: BackgroundShapeProps) {
  return (
    <img
      src="/imagens/bg-shape.svg"
      alt=""
      aria-hidden="true"
      style={{
        position: "absolute",
        width: size,
        top,
        right,
        opacity,
        pointerEvents: "none",
        transform: "rotate(330deg)",
        transformOrigin: "center",
        maxWidth: "100%",
        height: "auto",
        objectFit: "contain",
        zIndex: 0,
      }}
    />
  );
}